import { render, staticRenderFns } from "./RightTab.vue?vue&type=template&id=20ffba4f"
import script from "./RightTab.vue?vue&type=script&lang=js"
export * from "./RightTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports